export type BdAbteilungsart = 'HA' | 'BA' | 'n/a' | 'LEGACY';

export const BD_ABTEILUNGSART_DISPLAY_NAMES: {
  [abteilungsart in BdAbteilungsart]: string;
} = {
  HA: 'Hauptabteilung',
  BA: 'Belegabteilung',
  'n/a': 'Unbekannt',
  LEGACY: 'Nicht erhoben',
};
